import Item from '../../canvas-timeline/canvas_timeline_item';
import {ITEM_TYPE, drawRectangle, getTextColor, getTrimmedText, COMMON_IMAGE} from '../../canvas-timeline/canvas_timeline_util';
import {cacheManager} from '../../canvas-timeline/canvas_timeline_cache_manager';
import Util from '../../../../forecast-app/shared/util/util';

let userPilotSelectedTaskItem = null;

const positionUserPilotTag = (taskId, x, y, width, height, userPilotDocumentId) => {
	if (userPilotSelectedTaskItem === null || userPilotSelectedTaskItem === taskId) {
		const foregroundCanvas = document.getElementById('foreground-canvas');
		const canvasBounds = foregroundCanvas.getBoundingClientRect();
		const upElement = document.getElementById(userPilotDocumentId);
		if (x >= 0 && y >= 0 && x + width < canvasBounds.width && y + height < canvasBounds.height) {
			upElement.style.left = `${x + canvasBounds.x}px`;
			upElement.style.top = `${y + canvasBounds.y}px`;
			upElement.style.height = `${height}px`;
			upElement.style.width = `${width}px`;
			userPilotSelectedTaskItem = taskId;
		} else {
			upElement.style.left = '0';
			upElement.style.top = '0';
			upElement.style.height = '0';
			upElement.style.width = '0';
			userPilotSelectedTaskItem = null;
		}
	}
};

class TaskItem extends Item {
	constructor(data) {
		super(ITEM_TYPE.PEOPLE_SCHEDULING_TASK, data);
	}

	draw(canvasContext, x, y, width, canvasWidth) {
		const {data, height, startDate, endDate} = this;
		const {color, isHourEstimated, taskDayFragmentArray, task, intl} = data;

		if (this.groupId.indexOf('unassignedtask') > -1) {
			positionUserPilotTag(task.id, x, y, width, height, 'user-pilot-unassigned-task');
		}

		let {taskFragmentArray} = data;
		const pixelsPerDay = (width + 1) / (endDate - startDate + 1); //+1 to width because width is passed as 1 px less than it actually is to make 1px space between neighbouring items
		const textMargin = 16;
		const textColor = getTextColor(color);
		let currentFragmentX = x;
		if (this.isBeingDragged) {
			taskFragmentArray = [
				{
					isTask: true,
					position: 0,
					length: endDate - startDate + 1,
				},
			];
		}
		for (let j = 0; j < taskFragmentArray.length; j++) {
			const fragment = taskFragmentArray[j];
			//Subtract 1px from last fragment's width to make space between items that are next to eachother
			//It is normally automatically subtracted from width that is passed to draw but that param is not used to define item width in this case
			const isLastFragment = j === taskFragmentArray.length - 1;
			const fragmentWidth = pixelsPerDay * fragment.length - (isLastFragment ? 1 : 0);

			if (!fragment.isConnectingLine && !fragment.isTimeRegistration) {
				const options = {
					backgroundColor: color,
					backgroundOpacity: 0.7,
					isCornerTopRightCutOff: true,
				};
				drawRectangle(canvasContext, currentFragmentX, y, fragmentWidth, height, options);
				//Make clipping path in shape of the just-drawn rectangle
				canvasContext.save();
				canvasContext.clip();
				//Draw one big rectangle instead of many small ones if there are filled sections next to eachother
				//This way there are no vertical lines between each day that would otherwise be there due to subpixel rendering
				let filledSectionX = 0;
				let filledSectionLength = this.isBeingDragged ? endDate - startDate + 1 : 0;
				const timeEntries = [];
				if (!this.isBeingDragged) {
					for (let i = 0; i < taskDayFragmentArray.length; i++) {
						const dayFragment = taskDayFragmentArray[i];
						if (dayFragment.isFilled) {
							if (filledSectionLength) {
								filledSectionLength++;
							} else {
								filledSectionX = currentFragmentX + i * pixelsPerDay;
								filledSectionLength = 1;
							}
							if (dayFragment.minutesRegistered && pixelsPerDay > 105) {
								const minutes = dayFragment.minutesRegistered;
								const regMinutesString = Util.convertMinutesToFullHour(minutes, intl);
								const regMinutesStringWidth = canvasContext.measureText(regMinutesString).width;
								//if time entry on last day of task xCoord should be at the beginnig of the day to make space for task time left text
								const xCoord = i + 1 === taskDayFragmentArray.length ? currentFragmentX + i * pixelsPerDay + textMargin : currentFragmentX + (i + 1) * pixelsPerDay - (regMinutesStringWidth + textMargin);
								timeEntries.push({
									regMinutesString,
									xCoord,
								});
							}
						} else {
							if (filledSectionLength) {
								drawRectangle(canvasContext, filledSectionX, y, filledSectionLength * pixelsPerDay, height, {backgroundColor: color});
								filledSectionLength = 0;
							}
						}
					}
				}
				if (filledSectionLength) {
					drawRectangle(canvasContext, filledSectionX, y, filledSectionLength * pixelsPerDay, height, {backgroundColor: color});
				}
				canvasContext.restore(); //Remove clipping path
				//drawing text
				canvasContext.fillStyle = textColor;
				//time entries
				canvasContext.font = '400 12px ' + Util.getFontFamily();
				canvasContext.fillStyle = textColor;
				for (const obj of timeEntries) {
					canvasContext.fillText(obj.regMinutesString, obj.xCoord, y + 37);
				}
				//task forecast & timeleft
				canvasContext.font = '400 12px ' + Util.getFontFamily();
				let estimateForecastString;
				if (isHourEstimated) {
					estimateForecastString = Util.convertMinutesToFullHour(task.estimateForecast, intl);
				} else {
					estimateForecastString = intl.formatMessage({id: 'common.x_points'}, {points: task.estimateForecast});
				}
				const estimateForecastStringWidth = canvasContext.measureText(estimateForecastString).width;
				const visibleFragmentWidth = currentFragmentX + fragmentWidth > canvasWidth ? canvasWidth - currentFragmentX : fragmentWidth;

				//Don't write any text if there is no space for even forecast text
				if (estimateForecastStringWidth <= visibleFragmentWidth - 2 * textMargin) {
					const textPositionX = Util.clamp(currentFragmentX + visibleFragmentWidth - textMargin - estimateForecastStringWidth, currentFragmentX + textMargin, canvasWidth - textMargin - estimateForecastStringWidth);
					let maxEstStringWidth = 0;
					if (visibleFragmentWidth >= estimateForecastStringWidth + 21) {
						canvasContext.fillText(estimateForecastString, textPositionX, y + 21);
						let timeLeftStringWidth = 0;

						// prevent the estimation/forecast to overlap with the task name
						maxEstStringWidth = estimateForecastStringWidth > timeLeftStringWidth ? estimateForecastStringWidth + 5 : timeLeftStringWidth + 5;
					}
					//task name
					canvasContext.font = '400 12px ' + Util.getFontFamily();
					let taskNameXCoord = currentFragmentX + textMargin < 16 ? 16 : currentFragmentX + textMargin;
					let taskNameMaxWidth = taskNameXCoord === 16 ? (textPositionX - textMargin * 2 > 0 ? textPositionX - textMargin * 2 : 0) : visibleFragmentWidth - (48 + maxEstStringWidth);
					if (taskNameMaxWidth > 0) {
						if (task.highPriority) {
							canvasContext.drawImage(cacheManager.getCommonImage(COMMON_IMAGE.HIGH_PRIORITY_FLAG_WHITE), taskNameXCoord - 6, y + 8);
							taskNameXCoord += 10;
							taskNameMaxWidth -= 20;
						}
						if (task.bug) {
							if (task.highPriority) {
								taskNameXCoord += 3;
								taskNameMaxWidth -= 3;
							}
							canvasContext.drawImage(cacheManager.getCommonImage(COMMON_IMAGE.BUG), taskNameXCoord - 6, y + 8);
							taskNameXCoord += 10;
							taskNameMaxWidth -= 20;
						}
						if (taskNameMaxWidth > 0) {
							const formattedTaskName = getTrimmedText(canvasContext, task.name, taskNameMaxWidth);
							canvasContext.fillText(formattedTaskName, taskNameXCoord, y + 21);
						}
					}
				}
			}
			currentFragmentX += fragmentWidth;
		}
	}
}
export default TaskItem;
